import { makeStyles } from 'tss-react/mui';
import { GLOBAL_SCROLLBAR_WIDTH } from '../../../../../themes/v2/V2GlobalStyles';
import { AMOUNTS_CONVERSION_GAP_SPACING } from '../../orderTargets.constants';
import { getConversionColumnStyle } from '../../orderTargets.styles';

const ROW_HEIGHT = 24;
const ROW_GAP_SPACING = 0.25;
const VISIBLE_ROWS = 10;
const CONTENT_INLINE_SPACING = 1.5;
const SCROLLBAR_OFFSET_SPACING = 0.5;

const useOrderTargetBreakdownListStyles = makeStyles()((theme) => ({
  list: {
    display: 'grid',
    gridTemplateColumns: 'minmax(0, 1fr) auto auto',
    gridAutoRows: ROW_HEIGHT,
    alignItems: 'center',
    columnGap: theme.spacing(AMOUNTS_CONVERSION_GAP_SPACING),
    rowGap: theme.spacing(ROW_GAP_SPACING),
    maxHeight: `calc(${VISIBLE_ROWS * ROW_HEIGHT}px + ${theme.spacing((VISIBLE_ROWS - 1) * ROW_GAP_SPACING)})`,
    overflowY: 'auto',
    scrollbarGutter: 'stable',
    marginRight: theme.spacing(SCROLLBAR_OFFSET_SPACING),
    paddingLeft: theme.spacing(CONTENT_INLINE_SPACING),
    paddingRight: `calc(${theme.spacing(CONTENT_INLINE_SPACING - SCROLLBAR_OFFSET_SPACING)} - ${GLOBAL_SCROLLBAR_WIDTH}px)`,
  },
  amounts: {
    justifySelf: 'end',
    whiteSpace: 'nowrap',
    textBox: 'trim-both cap alphabetic',
  },
  conversion: getConversionColumnStyle(theme),
  loading: {
    padding: theme.spacing(0, CONTENT_INLINE_SPACING),
  },
}));

export default useOrderTargetBreakdownListStyles;
